"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createChildLogger = exports.logger = void 0;
const backendLogger_1 = require("./backendLogger");
const frontendLogger_1 = require("./frontendLogger");
exports.logger = typeof window !== 'undefined' ? (0, frontendLogger_1.logger)() : (0, backendLogger_1.logger)();
const createChildLogger = (requestId) => {
    return exports.logger.child({ x_request_id: requestId });
};
exports.createChildLogger = createChildLogger;
